import styled from 'styled-components';

export const PageHeaderStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 20px;
  flex-wrap: wrap;

  .text-box {
    min-width: 0;
    flex: 1 1 180px;
  }

  h1 {
    font-size: 22px;
    line-height: 28px;
    font-weight: 800;
    letter-spacing: -0.025em;
    color: var(--ink);
    margin: 0 0 6px;

    @media (min-width: 768px) {
      font-size: 30px;
      line-height: 36px;
      margin: 0 0 8px;
    }
  }

  .subtitle {
    margin: 0;
    color: var(--quiet);
    font-size: 13px;
    line-height: 18px;

    @media (min-width: 768px) {
      font-size: 15px;
      line-height: 22px;
    }
  }

  .actions {
    flex-shrink: 0;
    width: 100%;

    @media (min-width: 480px) {
      width: auto;
    }

    a {
      display: inline-flex;
      text-decoration: none;
      width: 100%;

      @media (min-width: 480px) {
        width: auto;
      }
    }

    button {
      width: 100%;
      min-width: 0;
      padding: 10px 16px;
      white-space: nowrap;
      border-radius: 9999px;

      @media (min-width: 480px) {
        width: auto;
      }
    }
  }
`;


export const OverlayScrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  background: rgba(10, 9, 8, 0.45);
  backdrop-filter: blur(5px);
  color: var(--ink);

  ${({ $placement }) =>
    $placement === 'center'
      ? `
    align-items: center;
    justify-content: center;
    padding: 16px;
  `
      : `
    align-items: center;
    justify-content: flex-end;
    padding: 0;

    @media (max-width: 640px) {
      align-items: stretch;
      justify-content: stretch;
    }
  `}
`;

export const OverlayDialog = styled.div`
  width: 100%;
  max-width: ${({ $width }) => ($width ? `${$width}px` : '480px')};
  overflow-y: auto;
  background: var(--card);
  padding: 20px 20px 24px;
  color: var(--ink);
  outline: none;

  ${({ $placement }) =>
    $placement === 'center'
      ? `
    height: auto;
    max-height: min(90dvh, 900px);
    border-radius: 22px;
    border: 1px solid var(--line);
    box-shadow: var(--shadow-lg);
    animation: overlayFadeIn 0.2s var(--ease);

    @keyframes overlayFadeIn {
      0% {
        opacity: 0;
        transform: translateY(8px) scale(0.98);
      }
      100% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  `
      : `
    height: 100%;
    max-height: 100dvh;
    border-left: 1px solid var(--line);
    border-radius: 0;
    box-shadow: var(--shadow-lg);
    animation: overlaySlideIn 0.28s var(--ease);

    @media (max-width: 640px) {
      max-width: 100%;
      border-left: 0;
      box-shadow: none;
    }

    @keyframes overlaySlideIn {
      0% {
        opacity: 0;
        transform: translateX(24px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
  `}

  label,
  .label {
    color: var(--ink);
  }
`;
export const OverlayHead = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  min-height: 40px;
  padding: 0 48px 14px 0;
  margin-bottom: 18px;
  border-bottom: 1px solid var(--line);

  .text-col {
    min-width: 0;
    flex: 1;
  }

  .title {
    display: block;
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: var(--ink);
    margin: 0;
  }

  .subtitle {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: var(--quiet);
  }

  .closer {
    position: absolute;
    top: 0;
    right: 0;
    width: 33px;
    height: 33px;
    font-size: 18px;
    line-height: 1;
    border: 1px solid var(--line);
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--quiet);
    padding: 0;
    background: var(--card-warm);
    outline: none;
    box-shadow: none;
    flex-shrink: 0;

    &:hover {
      color: var(--ink);
      border-color: var(--o1);
      background: var(--o-tint);
    }
  }

  @media (max-width: 500px) {
    .title {
      font-size: 18px;
      line-height: 24px;
    }

    .closer {
      width: 30px;
      height: 30px;
    }
  }
`;

export const OverlayFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-top: 24px;
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-top: 24px;

  > button {
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto;
    white-space: nowrap;
    min-height: 42px;
    padding: 10px 18px;
  }
`;

export const ConfirmIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $danger }) => ($danger ? 'rgba(215, 65, 32, 0.15)' : 'rgba(255, 75, 20, 0.15)')};
  color: ${({ $danger }) => ($danger ? 'var(--danger)' : '#ff6a3a')};
`;

export const ConfirmHead = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  h3 {
    margin: 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    color: var(--ink);
  }
`;

export const OverlayMessage = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: var(--quiet);
  margin: 0;
`;

export const ResourcePageStyled = styled.div`
  width: 100%;

  .toolbar {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;

    @media (min-width: 640px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tab {
    padding: 6px 16px;
    border-radius: 999px;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid var(--line);
    background: transparent;
    color: var(--quiet);
    text-transform: capitalize;

    &:hover,
    &.active {
      background: var(--card);
      color: var(--ink);
      border-color: var(--line);
      box-shadow: var(--shadow);
    }
  }

  .search {
    position: relative;
    width: 100%;

    @media (min-width: 640px) {
      width: 256px;
    }

    svg {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--quiet);
      pointer-events: none;
    }

    input {
      width: 100%;
      background: var(--card);
      border: 1px solid var(--line);
      border-radius: 999px;
      padding: 8px 12px 8px 36px;
      font-size: 14px;
      color: var(--ink);
      outline: none;
      box-shadow: var(--shadow);

      &::placeholder {
        color: var(--quiet);
      }

      &:focus {
        border-color: var(--o1);
        box-shadow: 0 0 0 3px var(--o-halo);
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    @media (min-width: 640px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1280px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .empty {
    padding: 80px 16px;
    text-align: center;
    color: var(--quiet);
    font-size: 14px;
  }

  .skeleton {
    height: 160px;
    border-radius: 22px;
    background: var(--card);
    border: 1px solid var(--line);
    animation: pulse 1.2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
  }
`;

export const CardMenuWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: 2;

  .trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid var(--line);
    color: var(--quiet);
    background: var(--card-warm);
    transition:
      color 0.15s ease,
      border-color 0.15s ease,
      background 0.15s ease;

    &:hover,
    &.open {
      color: var(--ink);
      border-color: var(--o1);
      background: var(--o-tint);
    }
  }
`;

export const CardMenuPanel = styled.div`
  position: fixed;
  z-index: 120;
  width: 200px;
  padding: 6px;
  border-radius: 12px;
  background: var(--card);
  border: 1px solid var(--line);
  box-shadow: var(--shadow-lg);
`;

export const CardMenuItemBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.2;
  text-align: left;
  background: transparent;
  color: ${({ $danger }) => ($danger ? 'var(--danger)' : 'var(--ink)')};

  svg {
    flex-shrink: 0;
  }

  span {
    min-width: 0;
  }

  &:hover {
    background: ${({ $danger }) => ($danger ? 'rgba(215, 65, 32, 0.12)' : 'var(--o-tint)')};
    color: ${({ $danger }) => ($danger ? 'var(--danger)' : 'var(--ink)')};
  }
`;

export const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 0;
  background: transparent;
  color: var(--quiet);
  font-size: 14px;

  &:hover {
    color: var(--o2);
  }
`;

export const ChatHeaderBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 12px 16px 12px 60px;
  border-bottom: 1px solid var(--line);
  background: var(--body-bg);

  @media (min-width: 768px) {
    padding: 12px 20px 12px 64px;
    gap: 12px;
  }

  @media (min-width: 1200px) {
    padding: 12px 24px;
    flex-wrap: nowrap;
  }

  .agent-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--o-tint);
    color: var(--o2);

    @media (min-width: 768px) {
      width: 36px;
      height: 36px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .agent-meta {
    flex: 1;
    min-width: 0;
  }

  .agent-name {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: var(--ink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .agent-sub {
    display: none;
    font-size: 12px;
    color: var(--quiet);

    @media (min-width: 480px) {
      display: block;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    width: 100%;
    margin-top: 4px;

    @media (min-width: 640px) {
      width: auto;
      margin-top: 0;
      margin-left: auto;
    }

    button {
      width: auto;
      min-width: 0;
      padding: 8px 12px;
      font-size: 13px;
      line-height: 1.2;
      border-radius: 9999px;
      white-space: nowrap;

      @media (min-width: 768px) {
        padding: 8px 14px;
        font-size: 14px;
      }
    }

    /* react-select control should flex on small screens */
    > div {
      flex: 1;
      min-width: 0;

      @media (min-width: 640px) {
        flex: 0 0 auto;
        min-width: 160px;
      }
    }
  }
`;


export const ChatEmptyState = styled.div`
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px 16px;

  @media (min-width: 768px) {
    min-height: 240px;
    padding: 24px;
  }

  .icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--o-tint);
    color: var(--o2);
    margin-bottom: 14px;

    @media (min-width: 768px) {
      width: 64px;
      height: 64px;
      margin-bottom: 16px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  h3 {
    font-size: 18px;
    font-weight: 800;
    color: var(--ink);
    margin: 0 0 8px;

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }

  p {
    font-size: 13px;
    color: var(--quiet);
    max-width: 420px;
    margin: 0;
    padding: 0 8px;

    @media (min-width: 768px) {
      font-size: 14px;
    }
  }
`;

export const TeamLayout = styled.div`
  display: grid;
  gap: 24px;
  align-items: start;
  color: var(--ink);

  @media (min-width: 992px) {
    grid-template-columns: 1fr 2fr;
  }

  .list-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    min-width: 0;
  }

  .section-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 280px;
    width: 100%;

    > div {
      min-height: 160px !important;
      height: auto !important;
      flex: 0 0 auto !important;
    }
  }

  .segment {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .segment-btn {
    flex: 1;
    padding: 6px 16px;
    border-radius: 999px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    border: 1px solid var(--line);
    background: transparent;
    color: var(--quiet);
    cursor: pointer;
    transition:
      background 0.15s ease,
      color 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease;

    &:hover,
    &.active {
      background: var(--card);
      color: var(--ink);
      border-color: var(--line);
      box-shadow: var(--shadow);
    }

    &.active {
      border-color: var(--o1);
      box-shadow: 0 0 0 3px var(--o-halo);
    }
  }

  .list-search {
    width: 100%;
    padding: 10px 12px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    font-size: 14px;
    outline: none;
    box-shadow: var(--shadow);

    &::placeholder {
      color: var(--quiet);
    }

    &:focus {
      border-color: var(--o1);
      box-shadow: 0 0 0 3px var(--o-halo);
    }
  }

  .team-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    text-align: left;
    padding: 14px 16px;
    border-radius: 14px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    margin-bottom: 8px;
    cursor: pointer;
    box-shadow: var(--shadow);
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;

    &:hover,
    &.active {
      border-color: var(--o1);
      box-shadow: var(--shadow-lg);
    }

    .icon {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      overflow: hidden;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--o-tint);
      color: var(--o2);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .copy {
      flex: 1;
      min-width: 0;
    }

    .name {
      display: block;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--ink);
    }

    .meta {
      font-size: 12px;
      color: var(--quiet);
    }

    .badge {
      flex-shrink: 0;
      font-size: 11px;
      font-weight: 600;
      padding: 3px 8px;
      border-radius: 999px;
      background: var(--o-tint);
      color: var(--o-deep);
      border: 1px solid var(--line);
    }
  }

  .editor-pane {
    border-radius: 22px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    padding: 24px;
    box-shadow: var(--shadow);
  }

  .empty-pane {
    min-height: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 48px 24px;
    border-radius: 22px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    box-shadow: var(--shadow);

    svg {
      color: var(--o2);
    }

    h3 {
      margin: 12px 0 6px;
      font-size: 16px;
      font-weight: 700;
      color: var(--ink);
    }

    p {
      margin: 0;
      font-size: 14px;
      color: var(--quiet);
      max-width: 28rem;
    }
  }
`;
